import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApiInstance from "app/services/axios";
import {
  getDataEndPoint,
  getStripePaymentPublisherKeyUrl,
  stripeRefundUrl,
  stripePaymentIntentUrl,
  updateAccountPaymentsUrl,
  updateDataEndPoint,
} from "app/utils/constants/paths";
import uuid from "react-uuid";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  historyloading: false,
  paymentHistoryList: [],
  totalPaymentHistory: 0,
};

export const CreateAccountPaymentDetails = createAsyncThunk(
  "payment/CreateAccountPaymentDetails",
  async (payload) => {
    let insertUpdateQuery = "";
    insertUpdateQuery =
      "insert into " +
      tablePrefix +
      "account_payment_details (id,name,account_id,email,phone,city,pincode,address1,country,state,pay_amount,creation_date,created_by,payment_gateway,is_recurring,recurring_amount,recurring_threshold,recurring_frequency,recurring_status) values('" +
      payload.id +
      "','" +
      addslashes(payload.name) +
      "','" +
      payload?.account_id +
      "','" +
      addslashes(payload.email) +
      "','" +
      payload.phone +
      "','" +
      addslashes(payload.city) +
      "','" +
      payload.zipcode +
      "','" +
      addslashes(payload.address) +
      "','" +
      payload.country +
      "','" +
      payload.state +
      "','" +
      payload.amount +
      "'," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      ",'" +
      payload.created_by +
      "','" +
      payload.payment_gateway +
      "'," +
      (payload.is_recurring || 0) +
      "," +
      (payload.recurring_amount ? "'" + payload.recurring_amount + "'" : "NULL") +
      "," +
      (payload.recurring_threshold ? "'" + payload.recurring_threshold + "'" : "NULL") +
      "," +
      (payload.recurring_frequency ? "'" + payload.recurring_frequency + "'" : "NULL") +
      "," +
      (payload.is_recurring ? "'active'" : "NULL") +
      ")";

    const queryBody = {
      queries: [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    //console.log("Sidd payload 1", payload);
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const UpdateAccountPaymentDetails = createAsyncThunk(
  "payment/UpdateAccountPaymentDetails",
  async (payload) => {
    const queryBody = {
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      resData: payload?.resData,
      column: payload?.column,
      account_payment_id: payload?.account_payment_id,
      paymentGateway: payload?.paymentGateway,
      ip_address: payload?.ip_address,
    };
    try {
      const response = await axiosApiInstance.post(
        updateAccountPaymentsUrl,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetUserPaymentDataForTable = createAsyncThunk(
  "payment/GetUserPaymentDataForTable",
  async (payload) => {
    let paymentWhere = "";
    let refundWhere = "";
    if (payload?.account_ids && payload.account_ids.length > 0) {
      paymentWhere =
        " and apd.account_id in ('" + payload.account_ids.join("','") + "')";
      refundWhere =
        " and apd.account_id in ('" + payload.account_ids.join("','") + "')";
    } else if (payload?.user_id && payload?.user_id != "") {
      paymentWhere = " and apd.created_by='" + payload?.user_id + "'";
      refundWhere = " and apd.created_by='" + payload?.user_id + "'";
    }
    const queryBody = {
      queries: [
        {
          query:
            "select * from (" +
            "select concat('payment_', apd.id) as id, apd.id as payment_id, apd.pay_amount as amount, apd.email, apd.phone, " +
            "(select name from countries where iso2=apd.country) as country, " +
            "DATE_FORMAT(apd.creation_date,'%Y-%m-%d %H:%i:%s') as date, " +
            "(select company from accounts where id=apd.account_id) as account, " +
            "apd.payment_gateway, apd.paypal_transaction_status, apd.status, apd.error_json, apd.is_recurring, apd.recurring_amount, apd.recurring_threshold, apd.recurring_frequency, apd.recurring_status, apd.reference_id, 'payment' as entry_type, " +
            "COALESCE((select ABS(SUM(af.payment)) from " +
            tablePrefix +
            "accounts_finance af where af.account_payment_details_id = apd.id and af.mode_of_payment = 'ad-refund'), 0) as refunded_amount, " +
            "(select DATE_FORMAT(MAX(af.creation_date),'%Y-%m-%d %H:%i:%s') from " +
            tablePrefix +
            "accounts_finance af where af.account_payment_details_id = apd.id and af.mode_of_payment = 'ad-refund') as refunded_date " +
            "from " +
            tablePrefix +
            "account_payment_details apd where apd.creation_date >='" +
            payload.start_date +
            "' and apd.creation_date <='" +
            payload.end_date +
            "' " +
            paymentWhere +
            " union all " +
            "select concat('refund_', af.id) as id, af.account_payment_details_id as payment_id, af.payment as amount, apd.email, apd.phone, " +
            "(select name from countries where iso2=apd.country) as country, " +
            "DATE_FORMAT(af.creation_date,'%Y-%m-%d %H:%i:%s') as date, " +
            "(select company from accounts where id=af.accountid) as account, " +
            "apd.payment_gateway, 'refunded' as paypal_transaction_status, 1 as status, '' as error_json, 0 as is_recurring, NULL as recurring_amount, NULL as recurring_threshold, NULL as recurring_frequency, NULL as recurring_status, apd.reference_id, 'refund' as entry_type, " +
            "ABS(af.payment) as refunded_amount, DATE_FORMAT(af.creation_date,'%Y-%m-%d %H:%i:%s') as refunded_date " +
            "from " +
            tablePrefix +
            "accounts_finance af inner join " +
            tablePrefix +
            "account_payment_details apd on apd.id = af.account_payment_details_id " +
            "where af.mode_of_payment = 'ad-refund' and af.creation_date >='" +
            payload.start_date +
            "' and af.creation_date <='" +
            payload.end_date +
            "' " +
            refundWhere +
            ") payment_history ORDER BY date DESC",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select (" +
            "COALESCE((select sum(apd.pay_amount) from " +
            tablePrefix +
            "account_payment_details apd where apd.creation_date >='" +
            payload.start_date +
            "' and apd.creation_date <='" +
            payload.end_date +
            "' AND (apd.status = '1' OR apd.paypal_transaction_status = 'succeeded' OR apd.paypal_transaction_status = 'COMPLETED') " +
            paymentWhere +
            "), 0) + " +
            "COALESCE((select sum(af.payment) from " +
            tablePrefix +
            "accounts_finance af inner join " +
            tablePrefix +
            "account_payment_details apd on apd.id = af.account_payment_details_id where af.mode_of_payment = 'ad-refund' and af.creation_date >='" +
            payload.start_date +
            "' and af.creation_date <='" +
            payload.end_date +
            "' " +
            refundWhere +
            "), 0)" +
            ") as total_payments",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetStripePublisherKey = createAsyncThunk(
  "payment/GetStripePublisherKey",
  async (payload) => {
    let body = {
      is_live: payload?.is_live,
    };
    try {
      const response = await axiosApiInstance.post(
        getStripePaymentPublisherKeyUrl,
        body
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const StripePaymentIntent = createAsyncThunk(
  "payment/StripePaymentIntent",
  async (payload) => {
    let body = {
      currency: payload?.currency,
      amount: payload?.amount,
      is_live: payload?.is_live,
      receipt_email: payload?.email,
      account_id: payload?.account_id || "",
      is_recurring: payload?.is_recurring || false,
      email: payload?.email || "",
    };
    try {
      const response = await axiosApiInstance.post(
        stripePaymentIntentUrl,
        body
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const RefundStripePayment = createAsyncThunk(
  "payment/RefundStripePayment",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(stripeRefundUrl, payload);
      return response;
    } catch (err) {
      console.log("RefundStripePayment error", err);
      throw err;
    }
  }
);

export const PreviewStripeRefund = createAsyncThunk(
  "payment/PreviewStripeRefund",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(stripeRefundUrl, {
        ...payload,
        preview_only: true,
      });
      return response;
    } catch (err) {
      console.log("PreviewStripeRefund error", err);
      throw err;
    }
  }
);

// ── Cancel Recurring Payment ─────────────────────────────────────────────
export const CancelRecurringPayment = createAsyncThunk(
  "payment/CancelRecurringPayment",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "UPDATE " +
            tablePrefix +
            "account_payment_details SET recurring_status = 'cancelled' WHERE id = '" +
            payload.payment_id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      return response;
    } catch (err) {
      console.log("CancelRecurringPayment error", err);
    }
  }
);

const Payment = createSlice({
  name: "payment",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder

      .addCase(CreateAccountPaymentDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(CreateAccountPaymentDetails.fulfilled, (state, action) => {
        if (!action.payload.data?.error) {
        }
        state.loading = false;
      })
      .addCase(CreateAccountPaymentDetails.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateAccountPaymentDetails.pending, (state) => {})
      .addCase(UpdateAccountPaymentDetails.fulfilled, (state, action) => {})
      .addCase(UpdateAccountPaymentDetails.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(GetUserPaymentDataForTable.pending, (state) => {
        state.historyloading = true;
      })
      .addCase(GetUserPaymentDataForTable.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let resultData = action.payload.data?.results[0];
          for (let i = 0; i < resultData.length; i++) {
            let dbInfo = resultData[i];
            dbInfo.status = "";
            const refundedAmount = Number(dbInfo?.refunded_amount || 0);
            const originalAmount = Number(dbInfo?.amount || 0);

            if (dbInfo?.entry_type === "refund") {
              dbInfo.status = "Refunded";
            } else if (refundedAmount > 0) {
              dbInfo.status =
                refundedAmount >= originalAmount
                  ? "Refunded"
                  : "Partially Refunded";
            } else if (
              dbInfo?.paypal_transaction_status != "" &&
              dbInfo?.paypal_transaction_status != null
            ) {
              if (dbInfo?.payment_gateway == "paypal") {
                dbInfo.status =
                  dbInfo.paypal_transaction_status == "COMPLETED"
                    ? "Success"
                    : dbInfo.paypal_transaction_status;
              } else {
                dbInfo.status =
                  dbInfo.paypal_transaction_status == "succeeded"
                    ? "Success"
                    : dbInfo.paypal_transaction_status;
              }
            } else {
              dbInfo.status = dbInfo.status == "1" ? "Success" : "Incomplete";
            }

            if (dbInfo.status == 0) {
              let errorJson =
                dbInfo?.error_json != "" && dbInfo?.error_json != null
                  ? JSON.parse(dbInfo?.error_json)
                  : "";
              if (Object.keys(errorJson).length > 0 && errorJson?.error) {
                dbInfo.status = "Fail";
              }
            }
            // Add recurring label
            if (dbInfo?.entry_type === "refund") {
              dbInfo.recurring_label = "Refund";
            } else if (dbInfo.is_recurring == 1 && dbInfo.recurring_status) {
              dbInfo.recurring_label =
                "Recurring (" + dbInfo.recurring_status.charAt(0).toUpperCase() +
                dbInfo.recurring_status.slice(1) + ")";
            } else if (dbInfo.reference_id) {
              dbInfo.recurring_label = "Auto-charged";
            } else {
              dbInfo.recurring_label = "One-time";
            }
            const paymentGateway = String(
              dbInfo?.payment_gateway || ""
            ).toLowerCase();
            const isStripePayment =
              paymentGateway === "stripepay" ||
              dbInfo?.paypal_transaction_status === "succeeded" ||
              dbInfo?.paypal_transaction_status === "partially_refunded" ||
              dbInfo?.paypal_transaction_status === "refunded";
            dbInfo.can_refund =
              dbInfo?.entry_type === "payment" &&
              isStripePayment &&
              (dbInfo?.status === "Success" ||
                dbInfo?.status === "Partially Refunded");
            dbInfo.phone =
              dbInfo.phone == null ? "" : dbInfo.phone.toString();
            delete dbInfo.error_json;
            delete dbInfo.paypal_transaction_status;
            resultData[i] = dbInfo;
          }
          let total_amount = action.payload.data?.results[1][0];

          state.paymentHistoryList = resultData;
          state.totalPaymentHistory = total_amount?.total_payments
            ? total_amount.total_payments
            : 0;
        }
        state.historyloading = false;
      })
      .addCase(GetUserPaymentDataForTable.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.historyloading = false;
      })
      .addCase(GetStripePublisherKey.pending, (state) => {})
      .addCase(GetStripePublisherKey.fulfilled, (state, action) => {})
      .addCase(GetStripePublisherKey.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(StripePaymentIntent.pending, (state) => {})
      .addCase(StripePaymentIntent.fulfilled, (state, action) => {})
      .addCase(StripePaymentIntent.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(RefundStripePayment.pending, (state) => {})
      .addCase(RefundStripePayment.fulfilled, (state, action) => {})
      .addCase(RefundStripePayment.rejected, (state) => {})
      .addCase(CancelRecurringPayment.pending, (state) => {})
      .addCase(CancelRecurringPayment.fulfilled, (state, action) => {})
      .addCase(CancelRecurringPayment.rejected, (state) => {});
  },
});
const { actions, reducer } = Payment;
// Extract and export each action creator by name
export const {
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
